<template>
  <div>
    <Loading v-if="loading"/>
    <div v-else>
      <div class="row d-none d-md-flex">
        <div class="col-lg-2" v-if="clientes.length > 1">
          <small>Cliente</small>
          <select v-model="clienteSeleccionado" class="form-control form-control-sm">
            <option :value="null">TODOS</option>
            <option v-for="cli in clientes" :key="cli.id" :value="cli.id">{{ cli.tomador }}</option>
          </select>
        </div>
        <div class="col-lg-6 pr-lg-1">
          <small>Buscador</small>
          <input type="text" v-model="searchTerm" class="form-control form-control-sm" placeholder="Buscar"/>
        </div>
        <div :class="{ 'col-md-2' : clientes.length > 1, 'col-md-3' : clientes.length <= 1 }">
          <small>Ordenar por</small>
          <select v-model="sortKey" class="form-control form-control-sm">
            <option value="fechaApertura">Fecha</option>
          </select>
        </div>
        <div  :class="{ 'col-md-2' : clientes.length > 1, 'col-md-3' : clientes.length <= 1 }" class="pl-lg-1">
          <small class="d-none d-lg-inline">&nbsp;</small>
          <select v-model="reverse" class="form-control form-control-sm">
            <option :value="false">Ascendente</option>
            <option :value="true">Descendente</option>
          </select>
        </div>
      </div>
      <hr class="mb-0 d-none d-md-flex"/>
      <div v-for="proyecto in filtered" :key="proyecto.id" 
        class="d-block d-md-flex py-2 border-bottom clickable list-item" 
        :class="{ 'bg-primary-light': selected == proyecto }"
        @dblclick="$emit('proyecto-seleccionado', proyecto)"
        @click="$emit('proyecto-seleccionado', proyecto)">

        <!-- LOGO -->
        <div class="d-block d-md-flex text-center text-md-left">
          <!-- <logo-cia :id="poliza.compania.id" class="text-center text-md-left px-2 img-lista"/> -->
        </div>
        <div class="d-block w-100">
          <!-- RAMO -->
          <h5 class="mb-0 text-primary-dark">{{ proyecto.cliente.tomador }}</h5>

          <!-- RIESGO -->
          <p class="mb-1">
            {{ proyecto.ramo.nombre }}
          </p>
            
          <!-- Nº POLIZA, VENCIMIENTO Y RECIBO -->
          <div class="row">
            <div class="col-md-4">
              <strong class="label-lista">Referencia:</strong>&nbsp;
              {{ proyecto.id }}
            </div>
            <div class="col-md-4">
              <strong class="label-lista">Fecha:</strong>&nbsp;
              {{ proyecto.fechaApertura|fecha}}
            </div>
            <div class="col-md-4">
              <strong class="label-lista">Etapa:</strong>&nbsp;
              <span v-if="proyecto.etapa">{{ proyecto.etapa.contenido }}</span>
            </div>
          </div>
        </div>
        <!--
        <div class="d-none d-md-flex text-center text-md-left">
          <button class="btn btn-primary h-100">{{ buttonText }}</button>
        </div>
        -->
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import LogoCia from '@/components/widgets/LogoCia'
import Loading from '@/components/widgets/Loading'
export default {
  data() {
    return {
      searchTerm: '',
      sortKey: 'fechaApertura',
      reverse: true,
      clienteSeleccionado: null
    }
  },
  props: {
    proyectos: {
      default: []
    },
    loading: {
      default: false
    },
    selected: {
      default: null
    }
  },
  computed: {
    clientes() {
      let clientes = []
      let done = []
      for (let i = 0; i < this.proyectos.length; i++) {
        if (done.indexOf(this.proyectos[i].cliente.id) == -1) {
          done.push(this.proyectos[i].cliente.id)
          clientes.push(this.proyectos[i].cliente)
        }
      }
      return clientes
    },
    filtered() {
      let filtered = [];
      let searchTerm = this.searchTerm.toLowerCase();
      if (this.searchTerm.length > 0 || this.clienteSeleccionado) {
        for (let i = 0; i < this.proyectos.length; i++) {
          let proyecto = this.proyectos[i];
          if (
            (proyecto.ramo.nombre && proyecto.ramo.nombre.toLowerCase().indexOf(searchTerm) != -1)
            || proyecto.id.toLowerCase().indexOf(searchTerm) != -1
            || (proyecto.cliente.tomador && proyecto.cliente.tomador.toLowerCase().indexOf(searchTerm) != -1)
          ) {
            if (this.clienteSeleccionado) {
              if (this.clienteSeleccionado == proyecto.cliente.id) {
                filtered.push(proyecto);  
              }
            } else {
              filtered.push(proyecto);
            }
          }
        }
      } else {
        filtered = this.proyectos
      }

      // Ordenar
      filtered = _.orderBy(filtered, this.sortKey, this.reverse ? 'desc' : 'asc');

      return filtered;
    }
  },
  components: {
    LogoCia,
    Loading
  }
}
</script>
<style>
.list-item.selected {
  background-color: #eee;
}
</style>
